import { Link } from 'react-router-dom';
import { events, categories } from '@/mocks/events';
import EventGridCard from '@/components/feature/EventCard';

export default function GridSection() {
  const shown = [...events].sort((a, b) => (b.status === '发酵中' ? 1 : 0) - (a.status === '发酵中' ? 1 : 0) || new Date(b.updated).getTime() - new Date(a.updated).getTime()).slice(0, 6);

  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide text-primary-600">
              <i className="ri-list-check-3" /> 精选栏目
            </span>
            <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">按栏目追更事件时间轴</h2>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap gap-2">
          {categories.filter((c) => c !== '全部').map((c) => (
            <Link
              key={c}
              to={`/events?cat=${encodeURIComponent(c)}`}
              className="group inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-all hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700"
            >
              <i className="ri-price-tag-3-line text-xs text-secondary-400 group-hover:text-primary-500" />
              {c}
            </Link>
          ))}
        </div>

        <h3 className="mt-10 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">最新收录 · 节点追踪中</h3>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((ev) => (
            <EventGridCard key={ev.id} event={ev} />
          ))}
        </div>
      </div>
    </section>
  );
}